import React from 'react';

export default function Intensity8(props) {
    return (
        <svg
            width="40px"
            height="36px"
            viewBox="0 0 40 36"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <title>Icon / Intensity Dial / 8</title>
            <desc>Created with Sketch.</desc>
            <g
                id="M---Athlete-Profile"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Session-Summary-/-Intensity-Slider-/-dial-all"
                    transform="translate(-291.000000, -387.000000)"
                    fill="#E81017"
                    fillRule="nonzero"
                >
                    <g
                        id="Icon-/-Intensity-Dial-/-8"
                        transform="translate(291.000000, 387.000000)"
                    >
                        <path
                            className={props.className}
                            // eslint-disable-next-line max-len
                            d="M28.4852814,13.5857864 L31.3137085,16.4142136 L21.4142136,26.3137085 L18.5857864,23.4852814 L28.4852814,13.5857864 Z M33.0020242,35.1973899 L30.4003902,32.1590514 C33.9310067,29.1358953 36,24.7382475 36,20 C36,11.163444 28.836556,4 20,4 C11.163444,4 4,11.163444 4,20 C4,24.5517916 5.90811984,28.7922831 9.20094766,31.8061003 L6.50029386,34.756773 C2.38802774,30.9929508 0,25.6859406 0,20 C0,8.954305 8.954305,-3.55271368e-15 20,-3.55271368e-15 C31.045695,-3.55271368e-15 40,8.954305 40,20 C40,25.919171 37.4109775,31.4221415 33.0020242,35.1973899 Z"
                            id="Shape"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
}
